import React from 'react';
import { Accordion } from '../ui/Accordion';
import { faqs } from '../../data/content';
export function FAQ() {
  return <section className="py-24 relative" data-id="element-46" data-mp="3926b3brvfjn6">
      <div className="container mx-auto px-4" data-id="element-47" data-mp="38z209vjwhpnj">
        <div className="text-center mb-16" data-id="element-48" data-mp="2u575ftgky0vc">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white flex items-center justify-center gap-3" data-id="element-49" data-mp="2u6iadwlrheo1">
            <span aria-hidden="true" data-id="element-50" data-mp="3mt31cvybror2">❓</span> LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <Accordion items={faqs} data-id="element-51" data-mp="3rrmp91whbam2" />
      </div>
    </section>;
}